'use strict';

goog.provide('Blockly.BlockFieldHelper');

/**
 * @enum {string}
 */
Blockly.BlockFieldHelper = {
  ANGLE_HELPER: 'Angle Helper'
};
